// Avoid using these colors directly. Instead, use the color variables in
// the current theme or the named colors below.

// These colors are used to generate the color variables.
export const rootColorsByHue:any = {
  white:        'rgb(255, 255, 255)', // Hex: ffffff,
  offWhite:     'rgb(240, 240, 250)', // Hex: f0f0ff,

  black:        'rgb(  0,   0,   0)', // Hex: 000000,
  offBlack:     'rgb( 34,  51,  84)', // Hex: 223354,

  blueLightest: 'rgb(221, 255, 255)', // Hex: ddeeff,
  blueLighter:  'rgb(170, 221, 255)', // Hex: 88ccff,
  blueLight:    'rgb(136, 204, 255)', // Hex: 88ccff,
  blue:         'rgb( 34, 170, 255)', // Hex: 22aaff,
  blueDark:     'rgb(  0, 119, 187)', // Hex: 0077bb,
  blueDarker:   'rgb(  0,  85, 136)', // Hex: 005588,
  blueDarkest:  'rgb(  0,  51,  85)', // Hex: 003355,

  tealLightest: 'rgb(221, 255, 255)', // Hex: ddeeff,
  tealLighter:  'rgb(187, 255, 255)', // Hex: bbffff,
  tealLight:    'rgb(153, 238, 238)', // Hex: 99eeee,
  teal:         'rgb( 34, 204, 204)', // Hex: 22cccc,
  tealDark:     'rgb(  0, 170, 170)', // Hex: 00aaaa,
  tealDarker:   'rgb(  0, 102, 102)', // Hex: 006666,
  tealDarkest:  'rgb(  0,  51,  51)', // Hex: 003333,

  greenLightest:'rgb(238, 255, 221)', // Hex: eeffdd,
  greenLighter: 'rgb(221, 255, 153)', // Hex: ddff99,
  greenLight:   'rgb(204, 255, 102)', // Hex: ccff66,
  green:        'rgb(136, 221,  17)', // Hex: 88dd11,
  greenDark:    'rgb(102, 153,   0)', // Hex: 669900,
  greenDarker:  'rgb( 51, 102,   0)', // Hex: 336600,
  greenDarkest: 'rgb(  0,  51,   0)', // Hex: 003300,

  yellowLightest:'rgb(255, 255, 221)', // Hex: ffffdd,
  yellowLighter:'rgb(255, 238, 170)', // Hex: ffeeaa,
  yellowLight:  'rgb(255, 238, 119)', // Hex: ffee77,
  yellow:       'rgb(255, 221,   0)', // Hex: ffdd00,
  yellowDark:   'rgb(221, 170,   0)', // Hex: ddaa00,
  yellowDarker: 'rgb(153, 102,   0)', // Hex: 996600,
  yellowDarkest:'rgb(102,  51,   0)', // Hex: 663300,

  orangeLightest:'rgb(255, 238, 204)', // Hex: ffeecc,
  orangeLighter:'rgb(255, 204, 153)', // Hex: ffcc99,
  orangeLight:  'rgb(255, 187, 119)', // Hex: ffbb77,
  orange:       'rgb(255, 153,  34)', // Hex: ff9922,
  orangeDark:   'rgb(221, 102,   0)', // Hex: dd6600,
  orangeDarker: 'rgb(153,  51,   0)', // Hex: 993300,
  orangeDarkest:'rgb(102,  34,   0)', // Hex: 662200,

  redLightest:  'rgb(255, 221, 221)', // Hex: ffdddd,
  redLighter:   'rgb(255, 136, 170)', // Hex: ff88aa,
  redLight:     'rgb(255, 102, 136)', // Hex: ff6688,
  red:          'rgb(255,  51, 102)', // Hex: ff3366,
  redDark:      'rgb(204,   0,  51)', // Hex: cc0033,
  redDarker:    'rgb(136,   0,  34)', // Hex: 880022,
  redDarkest:   'rgb( 68,   0,  17)', // Hex: 440011,

  pinkLightest: 'rgb(255, 238, 255)', // Hex: ffeeff,
  pinkLighter:  'rgb(255, 190, 255)', // Hex: ffaaff,
  pinkLight:    'rgb(255, 136, 255)', // Hex: ff88ff,
  pink:         'rgb(238,  68, 238)', // Hex: ee44ee,
  pinkDark:     'rgb(170,  17, 170)', // Hex: aa11aa,
  pinkDarker:   'rgb(102,   0, 102)', // Hex: 660066,
  pinkDarkest:  'rgb( 51,   0,  51)', // Hex: 330033,

  purpleLightest:'rgb(238, 221, 255)', // Hex: eeddff,
  purpleLighter:'rgb(221, 204, 255)', // Hex: ddccff,
  purpleLight:  'rgb(204, 170, 255)', // Hex: ccaaff,
  purple:       'rgb(170, 119, 255)', // Hex: aa77ff,
  purpleDark:   'rgb(119,  85, 187)', // Hex: 7755bb,
  purpleDarker: 'rgb( 68,  34, 136)', // Hex: 442288,
  purpleDarkest:'rgb( 34,  17,  68)', // Hex: 221144,

  beigeLightest:'rgb(255, 255, 238)', // Hex: ffffdd,
  beigeLighter: 'rgb(238, 221, 187)', // Hex: ddccaa,
  beigeLight:   'rgb(221, 204, 170)', // Hex: ddccaa,
  beige:        'rgb(204, 170, 102)', // Hex: ccaa66,
  beigeDark:    'rgb(153, 119,  51)', // Hex: 997733,
  beigeDarker:  'rgb(102,  68,  17)', // Hex: 664411,
  beigeDarkest: 'rgb( 51,  34,   0)', // Hex: 332200,

  grayLightest: 'rgb(238, 238, 238)', // Hex: eeeeee,
  grayLighter:  'rgb(187, 221, 238)', // Hex: bbddee,
  grayLight:    'rgb(170, 204, 221)', // Hex: aaccdd,
  gray:         'rgb(136, 153, 187)', // Hex: 8899bb,
  grayDark:     'rgb(102, 119, 153)', // Hex: 667799"
  grayDarker:   'rgb( 51,  68, 102)', // Hex: 334466,
  grayDarkest:  'rgb( 17,  34,  51)', // Hex: 112233,
};

export interface NamedColors {
  // Sentiment
  positive: string,
  positiveLight: string,
  positiveDark: string,

  negative: string,
  negativeLight: string,
  negativeDark: string,

  neutral: string,
  neutralLight: string,
  neutralDark: string,

  mixed: string,
  mixedLight: string,
  mixedDark: string,

  chartElement: string,

  // chart colors
  chart1: string,
  chart1Light: string,
  chart1Dark: string,

  chart2: string,
  chart2Light: string,
  chart2Dark: string,

  chart3: string,
  chart3Light: string,
  chart3Dark: string,

  chart4: string,
  chart4Light: string,
  chart4Dark: string,

  chart5: string,
  chart5Light: string,
  chart5Dark: string,

  chart6: string,
  chart6Light: string,
  chart6Dark: string,

  chart7: string,
  chart7Light: string,
  chart7Dark: string,

  chart8: string,
  chart8Light: string,
  chart8Dark: string,

  chart9: string,
  chart9Light: string,
  chart9Dark: string,

  // Gender

  female: string,
  femaleLight: string,
  femaleDark: string,

  male: string,
  maleLight: string,
  maleDark: string,

  nonbinary: string,
  nonbinaryLight: string,
  nonbinaryDark: string,

  // Passion

  passion: string,
  passionLight: string,
  passionLighter: string,
  passionDark: string,
  passionDarker: string,

  blogs: string,
  blogsLight: string,
  blogsDark: string,

  microblogs: string,
  microblogsLight: string,
  microblogsDark: string,

  twitter: string,
  twitterLight: string,
  twitterDark: string,

  x: string,
  xLight: string,
  xDark: string,

  images: string,
  imagesLight: string,
  imagesDark: string,

  forums: string,
  forumsLight: string,
  forumsDark: string,

  facebook: string,
  facebookLight: string,
  facebookDark: string,

  news: string,
  newsLight: string,
  newsDark: string,

  tumblr: string,
  tumblrLight: string,
  tumblrDark: string,

  instagram: string,
  instagramLight: string,
  instagramDark: string,

  pinterest: string,
  pinterestLight: string,
  pinterestDark: string,

  weibo: string,
  weiboLight: string,
  weiboDark: string,

  lexisnexis: string,
  lexisnexisLight: string,
  lexisnexisDark: string,

  reddit: string,
  redditLight: string,
  redditDark: string,

  threads: string,
  threadsLight: string,
  threadsDark: string,

  tiktok: string,
  tiktokLight: string,
  tiktokDark: string,

  vk: string,
  vkLight: string,
  vkDark: string,

  youtube: string,
  youtubeLight: string,
  youtubeDark: string,

  linkedin: string,
  linkedinLight: string,
  linkedinDark: string,

  bluesky: string,
  blueskyLight: string,
  blueskyDark: string,

  uncategorized: string,
  uncategorizedLight: string,
  uncategorizedDark: string,

  queryOr: string,
  queryOrBorder: string,
  queryOrBorderTop: string,

  queryAnd: string,
  queryAndBorder: string,
  queryAndBorderTop: string,

  queryNot: string,
  queryNotBorder: string,
  queryNotBorderTop: string,

  queryContains: string,
  queryContainsBorder: string,
  queryContainsBorderTop: string,

  queryBoolean: string,
  queryBooleanBorder: string,
  queryBooleanBorderTop: string,

  querySpan: string,
  querySpanBorder: string,
  querySpanBorderTop: string,

  queryCompare: string,
  queryCompareBorder: string,
  queryCompareBorderTop: string,

  queryMatch: string,
  queryMatchBorder: string,
  queryMatchBorderTop: string,

  queryRange: string,
  queryRangeBorder: string,
  queryRangeBorderTop: string,

  queryUndefined: string,
  queryUndefinedBorder: string,
  queryUndefinedBorderTop: string,

  dropBackgroundColor: string,

  chartColorArray: string[],
  colorPalletteArray: string[],

  aiGradient: string,
  aiAnimation: string,
  aiButtonText: string
}

export const lightModeNamedColors:NamedColors = {

  // Sentiment
  positive: rootColorsByHue.green,
  positiveLight: rootColorsByHue.greenLight,
  positiveDark: rootColorsByHue.greenDark,

  negative: rootColorsByHue.red,
  negativeLight: rootColorsByHue.redLight,
  negativeDark: rootColorsByHue.redDark,

  neutral: rootColorsByHue.gray,
  neutralLight: rootColorsByHue.grayLight,
  neutralDark: rootColorsByHue.grayDark,

  mixed: rootColorsByHue.yellow,
  mixedLight: rootColorsByHue.yellowLight,
  mixedDark: rootColorsByHue.yellowDark,

  // chart colors
  chartElement: rootColorsByHue.grayLight,

  chart1: rootColorsByHue.blue,
  chart1Light: rootColorsByHue.blueLight,
  chart1Dark: rootColorsByHue.blueDark,

  chart2: rootColorsByHue.orange,
  chart2Light: rootColorsByHue.orangeLight,
  chart2Dark: rootColorsByHue.orangeDark,

  chart3: rootColorsByHue.teal,
  chart3Light: rootColorsByHue.tealLight,
  chart3Dark: rootColorsByHue.tealDark,

  chart4: rootColorsByHue.yellow,
  chart4Light: rootColorsByHue.yellowLight,
  chart4Dark: rootColorsByHue.yellowDark,

  chart5: rootColorsByHue.purple,
  chart5Light: rootColorsByHue.purpleLight,
  chart5Dark: rootColorsByHue.purpleDark,

  chart6: rootColorsByHue.pink,
  chart6Light: rootColorsByHue.pinkLight,
  chart6Dark: rootColorsByHue.pinkDark,

  chart7: rootColorsByHue.beige,
  chart7Light: rootColorsByHue.beigeLight,
  chart7Dark: rootColorsByHue.beigeDark,

  chart8: rootColorsByHue.green,
  chart8Light: rootColorsByHue.greenLight,
  chart8Dark: rootColorsByHue.greenDark,

  chart9: rootColorsByHue.red,
  chart9Light: rootColorsByHue.redLight,
  chart9Dark: rootColorsByHue.redDark,

  // Gender

  female: rootColorsByHue.pink,
  femaleLight: rootColorsByHue.pinkLight,
  femaleDark: rootColorsByHue.pinkDark,

  male: rootColorsByHue.blue,
  maleLight: rootColorsByHue.blueLight,
  maleDark: rootColorsByHue.blueDark,

  nonbinary: rootColorsByHue.purple,
  nonbinaryLight: rootColorsByHue.purpleLight,
  nonbinaryDark: rootColorsByHue.purpleDark,

  // Passion

  passion: rootColorsByHue.purple,
  passionLight: rootColorsByHue.purpleLight,
  passionLighter: rootColorsByHue.purpleLighter,
  passionDark: rootColorsByHue.purpleDark,
  passionDarker: rootColorsByHue.purpleDarker,

  blogs: rootColorsByHue.orange,
  blogsLight: rootColorsByHue.orangeLight,
  blogsDark: rootColorsByHue.orangeDark,

  microblogs: rootColorsByHue.blue,
  microblogsLight: rootColorsByHue.blueLight,
  microblogsDark: rootColorsByHue.blueDark,

  twitter: rootColorsByHue.blue,
  twitterLight: rootColorsByHue.blueLight,
  twitterDark: rootColorsByHue.blueDark,

  x: rootColorsByHue.black,
  xLight: rootColorsByHue.black,
  xDark: rootColorsByHue.black,

  images: rootColorsByHue.red,
  imagesLight: rootColorsByHue.redLight,
  imagesDark: rootColorsByHue.redDark,

  forums: rootColorsByHue.green,
  forumsLight: rootColorsByHue.greenLight,
  forumsDark: rootColorsByHue.greenDark,

  facebook: rootColorsByHue.purple,
  facebookLight: rootColorsByHue.purpleLight,
  facebookDark: rootColorsByHue.purpleDark,

  news: rootColorsByHue.beige,
  newsLight: rootColorsByHue.beigeLight,
  newsDark: rootColorsByHue.beigeDark,

  tumblr: rootColorsByHue.orange,
  tumblrLight: rootColorsByHue.orangeLight,
  tumblrDark: rootColorsByHue.orangeDark,

  instagram: rootColorsByHue.pink,
  instagramLight: rootColorsByHue.pinkLight,
  instagramDark: rootColorsByHue.pinkDark,

  pinterest: rootColorsByHue.red,
  pinterestLight: rootColorsByHue.redLight,
  pinterestDark: rootColorsByHue.redDark,

  weibo: rootColorsByHue.red,
  weiboLight: rootColorsByHue.redLight,
  weiboDark: rootColorsByHue.redDark,

  lexisnexis: rootColorsByHue.red,
  lexisnexisLight: rootColorsByHue.redLight,
  lexisnexisDark: rootColorsByHue.redDark,

  reddit: rootColorsByHue.orange,
  redditLight: rootColorsByHue.orangeLight,
  redditDark: rootColorsByHue.orangeDark,

  threads: rootColorsByHue.black,
  threadsLight: rootColorsByHue.blackLight,
  threadsDark: rootColorsByHue.blackDark,

  tiktok: rootColorsByHue.teal,
  tiktokLight: rootColorsByHue.tealLight,
  tiktokDark: rootColorsByHue.tealDark,

  vk: rootColorsByHue.blue,
  vkLight: rootColorsByHue.blueLight,
  vkDark: rootColorsByHue.blueDark,

  youtube: rootColorsByHue.red,
  youtubeLight: rootColorsByHue.redLight,
  youtubeDark: rootColorsByHue.redDark,

  linkedin: rootColorsByHue.blue,
  linkedinLight: rootColorsByHue.blueLight,
  linkedinDark: rootColorsByHue.blueDark,

  bluesky: rootColorsByHue.blue,
  blueskyLight: rootColorsByHue.blueLight,
  blueskyDark: rootColorsByHue.blueDark,

  uncategorized: rootColorsByHue.gray,
  uncategorizedLight: rootColorsByHue.grayLight,
  uncategorizedDark: rootColorsByHue.grayDark,

  // Boolean Query Operators
  queryOr: rootColorsByHue.blueLighter,
  queryOrBorder: rootColorsByHue.blue,
  queryOrBorderTop: rootColorsByHue.blueLightest,

  queryAnd: rootColorsByHue.greenLighter,
  queryAndBorder: rootColorsByHue.greenDark,
  queryAndBorderTop: rootColorsByHue.white,

  queryNot: rootColorsByHue.redLighter,
  queryNotBorder: rootColorsByHue.red,
  queryNotBorderTop: rootColorsByHue.redLightest,

  queryContains: rootColorsByHue.purpleLighter,
  queryContainsBorder: rootColorsByHue.purple,
  queryContainsBorderTop: rootColorsByHue.purpleLightest,

  queryBoolean: rootColorsByHue.yellowLighter,
  queryBooleanBorder: rootColorsByHue.yellowDark,
  queryBooleanBorderTop: rootColorsByHue.white,

  querySpan: rootColorsByHue.orangeLighter,
  querySpanBorder: rootColorsByHue.orange,
  querySpanBorderTop: rootColorsByHue.orangeLightest,

  queryCompare: rootColorsByHue.tealLighter,
  queryCompareBorder: rootColorsByHue.tealDark,
  queryCompareBorderTop: rootColorsByHue.tealLightest,

  queryMatch: rootColorsByHue.beigeLighter,
  queryMatchBorder: rootColorsByHue.beige,
  queryMatchBorderTop: rootColorsByHue.beigeLightest,

  queryRange: rootColorsByHue.pinkLighter,
  queryRangeBorder: rootColorsByHue.pink,
  queryRangeBorderTop: rootColorsByHue.pinkLightest,

  queryUndefined: rootColorsByHue.grayLighter,
  queryUndefinedBorder: rootColorsByHue.gray,
  queryUndefinedBorderTop: rootColorsByHue.grayLightest,

  dropBackgroundColor: "rgba(255, 255, 255, 0.3)",

  chartColorArray: [],
  colorPalletteArray: [],

  aiGradient: `linear-gradient(45deg,
    ${rootColorsByHue.teal} 0%,
    ${rootColorsByHue.blue} 20%,
    ${rootColorsByHue.purple} 35%,
    ${rootColorsByHue.pink} 50%,
    ${rootColorsByHue.purple} 65%,
    ${rootColorsByHue.blue} 80%,
    ${rootColorsByHue.teal} 100%)`,
  aiAnimation: 'border-shimmer 6s ease-in-out infinite',
  aiButtonText: rootColorsByHue.white
};

lightModeNamedColors.chartColorArray = [
  lightModeNamedColors.chart1, lightModeNamedColors.chart2, lightModeNamedColors.chart3, lightModeNamedColors.chart4, lightModeNamedColors.chart5, lightModeNamedColors.chart6, lightModeNamedColors.chart7, lightModeNamedColors.chart8, lightModeNamedColors.chart9,
  lightModeNamedColors.chart1Dark, lightModeNamedColors.chart2Dark, lightModeNamedColors.chart3Dark, lightModeNamedColors.chart4Dark, lightModeNamedColors.chart5Dark, lightModeNamedColors.chart6Dark, lightModeNamedColors.chart7Dark, lightModeNamedColors.chart8Dark, lightModeNamedColors.chart9Dark,
  lightModeNamedColors.chart1Light, lightModeNamedColors.chart2Light, lightModeNamedColors.chart3Light, lightModeNamedColors.chart4Light, lightModeNamedColors.chart5Light, lightModeNamedColors.chart6Light, lightModeNamedColors.chart7Light, lightModeNamedColors.chart8Light, lightModeNamedColors.chart9Light
];

lightModeNamedColors.colorPalletteArray = [
  rootColorsByHue.white, rootColorsByHue.blueLighter, rootColorsByHue.tealLighter, rootColorsByHue.greenLighter, rootColorsByHue.yellowLighter, rootColorsByHue.orangeLighter, rootColorsByHue.redLighter, rootColorsByHue.pinkLighter, rootColorsByHue.purpleLighter, rootColorsByHue.beigeLighter,
  rootColorsByHue.gray, rootColorsByHue.blue, rootColorsByHue.teal, rootColorsByHue.green, rootColorsByHue.yellow, rootColorsByHue.orange, rootColorsByHue.red, rootColorsByHue.pink, rootColorsByHue.purple, rootColorsByHue.beige,
  rootColorsByHue.black, rootColorsByHue.blueDarker, rootColorsByHue.tealDarker, rootColorsByHue.greenDarker, rootColorsByHue.yellowDarker, rootColorsByHue.orangeDarker, rootColorsByHue.redDarker, rootColorsByHue.pinkDarker, rootColorsByHue.purpleDarker, rootColorsByHue.beigeDarker];

export const darkModeNamedColors:NamedColors = {
  ...lightModeNamedColors,

  // Boolean Query Operators
  queryOr: rootColorsByHue.blueDarker,
  queryOrBorder: rootColorsByHue.blueDarkest,
  queryOrBorderTop: rootColorsByHue.blue,

  queryAnd: rootColorsByHue.greenDarker,
  queryAndBorder: rootColorsByHue.greenDarkest,
  queryAndBorderTop: rootColorsByHue.greenDark,

  queryNot: rootColorsByHue.redDarker,
  queryNotBorder: rootColorsByHue.redDarkest,
  queryNotBorderTop: rootColorsByHue.redDark,

  queryContains: rootColorsByHue.purpleDarker,
  queryContainsBorder: rootColorsByHue.purpleDarkest,
  queryContainsBorderTop: rootColorsByHue.purpleDark,

  queryBoolean: rootColorsByHue.yellowDarker,
  queryBooleanBorder: rootColorsByHue.beigeDarkest,
  queryBooleanBorderTop: rootColorsByHue.yellowDark,

  querySpan: rootColorsByHue.orangeDarker,
  querySpanBorder: rootColorsByHue.orangeDarkest,
  querySpanBorderTop: rootColorsByHue.orangeDark,

  queryCompare: rootColorsByHue.tealDarker,
  queryCompareBorder: rootColorsByHue.tealDarkest,
  queryCompareBorderTop: rootColorsByHue.tealDark,

  queryMatch: rootColorsByHue.beigeDarker,
  queryMatchBorder: rootColorsByHue.beigeDarkest,
  queryMatchBorderTop: rootColorsByHue.beigeDark,

  queryRange: rootColorsByHue.pinkDarker,
  queryRangeBorder: rootColorsByHue.pinkDarkest,
  queryRangeBorderTop: rootColorsByHue.pinkDark,

  queryUndefined: rootColorsByHue.grayDarker,
  queryUndefinedBorder: rootColorsByHue.grayDarkest,
  queryUndefinedBorderTop: rootColorsByHue.grayDark,

  uncategorized: rootColorsByHue.gray,
  uncategorizedLight: rootColorsByHue.grayDark,
  uncategorizedDark: rootColorsByHue.grayLight,

  dropBackgroundColor: "rgba(0, 0, 0, 0.2)",

  chartColorArray: []
};

darkModeNamedColors.chartColorArray = [
  darkModeNamedColors.chart1, darkModeNamedColors.chart2, darkModeNamedColors.chart3, darkModeNamedColors.chart4, darkModeNamedColors.chart5, darkModeNamedColors.chart6, darkModeNamedColors.chart7, darkModeNamedColors.chart8, darkModeNamedColors.chart9,
  darkModeNamedColors.chart1Light, darkModeNamedColors.chart2Light, darkModeNamedColors.chart3Light, darkModeNamedColors.chart4Light, darkModeNamedColors.chart5Light, darkModeNamedColors.chart6Light, darkModeNamedColors.chart7Light, darkModeNamedColors.chart8Light, darkModeNamedColors.chart9Light,
  darkModeNamedColors.chart1Dark, darkModeNamedColors.chart2Dark, darkModeNamedColors.chart3Dark, darkModeNamedColors.chart4Dark, darkModeNamedColors.chart5Dark, darkModeNamedColors.chart6Dark, darkModeNamedColors.chart7Dark, darkModeNamedColors.chart8Dark, darkModeNamedColors.chart9Dark
];

// These two modes share a color pallete, just inverted - so for color pickers they can match.
// Other themes might have different pallettes.
darkModeNamedColors.colorPalletteArray = lightModeNamedColors.colorPalletteArray;